import React, { FC } from 'react';
import { FetchOrderProductsLineItem } from '../../api/orders/fetchOrder';
import { OrdersDetailsProductListItem } from './OrdersDetailsProductListItem';
import { InvoiceOut } from '../../store/api';
import classnames from 'classnames';

type Props = {
    readonly orderId: string;
    readonly lineItems: ReadonlyArray<FetchOrderProductsLineItem>;
    readonly onDownloadInvoice: (invoice: InvoiceOut) => void;
};

export const OrdersDetailsProductList: FC<Props> = ({ orderId, lineItems, onDownloadInvoice }) => {
    const className = classnames('overwrite-legacy-css-for-ProductList', 'product-list-container-new');

    return (
        <div className={className}>
            {lineItems.map(lineItem => (
                <OrdersDetailsProductListItem
                    key={`${lineItem.id}-${lineItem.usageCondition}-${lineItem.usageLimit}-${lineItem.termLimit}`}
                    orderId={orderId}
                    product={lineItem}
                    onDownloadInvoice={onDownloadInvoice}
                />
            ))}
        </div>
    );
};
